import http from "../Utilities/http";


export const  getRecipients = () =>  {
  return http.get("/branches")
    .catch(error => {});
}
export const getShippingOrderFormEffective = () =>{
  return http.get("/shippingorder/form-config")
    .catch(error => {});
}
export const getUsers = () => {
  return http.get("/admin/user");
}

export const getShippingOrderFormConfig = (level, targetId) => {
  level = getLevel(level);
  return http
    .get(`/admin/shippingorderformconfig/${level}/${targetId}`)
    .then((res) => res?.data?.configJson)
    .catch(error => {});
};

export const  updateShippingOrderFormConfig = (level, id, configJson) => {
  level = getLevel(level);
  return http.post("/admin/shippingorderformconfig", {
    "configLevel": level.charAt(0).toUpperCase() + level.slice(1),
    "targetId": id,
    "configJson": configJson
  });
};

export const deleteShippingOrderFormConfig = (level, targetId) => {
  return http.delete(`/admin/shippingorderformconfig/${level}/${targetId}`);
};


const getLevel = (level) => {
  const levelMap = {
    taxRegistrationNumber: 'client',
    default: 'global',
  };
  return levelMap[level] || level;
};
